import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M108 41.87C108 41.87 80.37 27.42 78.97 25.66C77.57 23.9 76.63 1 76.63 1H54.62C54.62 1 53.68 23.9 52.28 25.66C50.88 27.42 23.25 41.87 23.25 41.87C23.25 41.87 35.5 56.92 65.63 56.92C95.75 56.92 108 41.87 108 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.72 47.56C118.64 43.93 84.08 26.75 84.08 26.75L78.95 17.17L65.62 38.72L52.29 17.17L47.16 26.75C47.16 26.75 12.6 43.92 9.51996 47.56C6.43996 51.19 2 73.54 2 73.54H129.23C129.24 73.54 124.79 51.2 121.72 47.56Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.6204 49.6501C66.6145 49.6501 67.4203 48.8442 67.4203 47.8501C67.4203 46.8559 66.6145 46.05 65.6204 46.05C64.6262 46.05 63.8203 46.8559 63.8203 47.8501C63.8203 48.8442 64.6262 49.6501 65.6204 49.6501Z"
        fill={secondaryOutline}
      />
      <path
        d="M65.6204 67.35C66.6145 67.35 67.4203 66.5441 67.4203 65.55C67.4203 64.5559 66.6145 63.75 65.6204 63.75C64.6262 63.75 63.8203 64.5559 63.8203 65.55C63.8203 66.5441 64.6262 67.35 65.6204 67.35Z"
        fill={secondaryOutline}
      />
      <path
        d="M45.6198 27.0699L56.5198 73.6399H2.00977C2.00977 73.6399 6.55978 49.9899 9.45978 47.2199C13.6298 43.2299 45.6198 27.0699 45.6198 27.0699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M58.5597 28.11L51.3497 45.4L47.1396 26.86"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M40.7305 30.37L50.7405 73.63" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M85.5699 27.0699L74.6699 73.6399H129.18C129.18 73.6399 124.63 49.9899 121.73 47.2199C117.56 43.2299 85.5699 27.0699 85.5699 27.0699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M72.6299 28.1099L79.8398 45.3999L84.1299 26.5699"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M90.4702 30.37L80.4502 73.63" stroke={outline} strokeMiterlimit="10" />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6228"
          y1="31.0368"
          x2="65.6228"
          y2="20.2006"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
